// Public site key from backend (safe to expose in browser)
const RECAPTCHA_SITE_KEY = window.__RECAPTCHA_SITE_KEY__ || '';

export function loadRecaptchaScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!RECAPTCHA_SITE_KEY) {
      // Skip reCAPTCHA loading in test/development when not configured
      resolve();
      return;
    }

    if (window.grecaptcha) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.onload = () => {
      window.grecaptcha?.ready(() => resolve());
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

export async function executeRecaptcha(action: string): Promise<string | null> {
  // Return placeholder token when reCAPTCHA is not configured (test/dev environments)
  if (!RECAPTCHA_SITE_KEY || !window.grecaptcha) {
    return 'test_token';
  }

  try {
    return await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
  } catch (error) {
    console.error('reCAPTCHA execution failed:', error);
    return null;
  }
}
